<template>
  <div>
    <asset-register />
    <router-view />
  </div>
</template>

<script>
import AssetRegister from './AssetRegister.vue'

export default {
  name: 'RegisterAssets',
  components: {
    AssetRegister
  }
}
</script>
<style></style>
